<template>
    <section class="simple-text">
        <b-container>
            <b-row align-h="center">
                <b-col class="content" cols="12" lg="10" v-html="payload.content"></b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
    export default {
        name: "SimpleText",
        props: ['payload']
    }
</script>

<style lang="scss">
    section.simple-text{
        background: #e5e5e5;
        color: $black;
        padding-top: 80px;
        padding-bottom: 80px;

        @include media-breakpoint-up(lg){
            padding-top: 104px;
            padding-bottom: 104px;
        }

        .content{
            h3 {
                margin-bottom: 3rem;
            }

            *:last-child {
              margin-bottom: 0;
            }
        }
    }
</style>